<template>
  <div class="c-smart-cover">
    <Row class="row-item" :gutter="12">
      <Col span="4" class="col-item">
        <span class="item-field">{{ description }}</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="smart" type="button">
          <Radio :label="0">自定义</Radio>
          <Radio :label="1">智能抽帧</Radio>
        </RadioGroup>
      </Col>
    </Row>

    <Row class="row-item" :gutter="12" v-if="!smart">
      <Col span="4" class="col-item">
        <span class="item-field">&nbsp;</span>
      </Col>
      <Col span="20">
        <span class="c-cover-title">封面图片{{ len }}/{{ max }}</span>
        <div class="c-cover-wrap">
          <div v-if="msg" class="c-col-msg">
            <span>{{ msg }}</span>
          </div>
          <smart-item v-for="(item, i) in data" :key="i" closable @close="delView(i)">
            <creat-image
              v-model="item[item.name]"
              :name="item.name"
              :mode="item.element"
              :width="item.restriction.width"
              :height="item.restriction.height"
              :size="item.restriction.file_size"
              :format="item.restriction.file_format"
              :required="item.required"
              :description="item.description"
              :verify="verify"
              :source="source"
              :scene-id="sceneId"
              :local="local"
              @select="select(...arguments, i)"
            />
          </smart-item>
          <smart-item>
            <upload-button v-if="len !== max" @on-click="$emit('on-add', max - len)">
              <span>选择封面</span>
            </upload-button>
          </smart-item>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import CreatImage from './creat-image.vue'
import UploadButton from './upload-button'
import SmartItem from './smart-item'
export default {
  name: 'smartCover',
  components: { CreatImage, UploadButton, SmartItem },
  props: {
    value: {
      type: Number
    },
    data: {
      type: Array
    },
    description: {
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: 4
    },
    sceneId: {
      type: Number
    },
    source: {
      type: Array
    },
    verify: {
      type: Boolean
    },
    required: {
      type: Boolean
    },
    local: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    smart: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    len() {
      return this.data.length
    },
    msg() {
      return this.verify && this.required && !this.len ? `${this.description}不能为空` : ''
    }
  },
  methods: {
    delView(index) {
      this.$emit('on-delete', index)
    },
    select() {
      const param = arguments[0]
      const index = arguments[1]
      this.$emit('on-select', { param, index })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-smart-cover {
  .c-cover-title {
    font-size: 14px;
    line-height: 1.2;
  }

  .c-cover-wrap {
    position: relative;
  }

  .c-col-msg {
    position: absolute;
    z-index: 4;
    left: 0;
    bottom: -18px;
    color: #ff4400;
  }
}
</style>
